module.exports = __webpack_public_path__ + "static/media/ic_menu.ba036a4c.svg";